import React from "react";
import "./Armont1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card.jsx";
import Armont8images from "../../../Media/BSD/Armont/Tipe 8/Armont8.js";
import Armont9images from "../../../Media/BSD/Armont/Tipe 9/Armont9.js";
import Armont10images from "../../../Media/BSD/Armont/Tipe 10/Armont10.js";

const imageMap = {
  Armont8images,
  Armont9images,
  Armont10images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="armont" className="produk">
      <h1>Welcome to Armont</h1>
      <h2>Cicilan Start 24 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
